import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';
import type { RegistrationCallOutcomeInput } from '@/models/callLog';

export const saveRegistrationCallOutcome = async ({
  phoneNumber,
  reason,
  details,
  callLogId,
  hearAboutUs,
}: RegistrationCallOutcomeInput) => {
  const response = await mutationExecute({
    variables: {
      phoneNumber,
      reason,
      details,
      callLogId,
      hearAboutUs,
    },
    mutation: graphql(`
      mutation SaveRegistrationCallOutcome(
        $phoneNumber: String!
        $reason: String!
        $callLogId: Float!
        $details: String
        $hearAboutUs: String
      ) {
        saveRegistrationCallOutcome(
          phoneNumber: $phoneNumber
          reason: $reason
          details: $details
          callLogId: $callLogId
          hearAboutUs: $hearAboutUs
        ) {
          id
          phoneNumber
          reason
          callLogId
        }
      }
    `),
  });

  return response.data?.saveRegistrationCallOutcome;
};
